import React from 'react'
import { CanonicalLoad, ClientLoadModel } from '@numeo/types-core'
import { EmailChatCard } from '../EmailChatCard'

interface PrivateLoadEmailChatProps {
    load: CanonicalLoad
    emailThreadId: string
    loadMongoId?: string
    isExpanded: boolean
    /** Show "Send again" under our own sent emails (Box Truck drawer). */
    allowResend?: boolean
    /** Outcome of each confirmed resend — the host records it in its own analytics. */
    onResent?: (outcome: 'sent' | 'failed') => void
}

export const PrivateLoadEmailChat: React.FC<PrivateLoadEmailChatProps> = ({ load, emailThreadId, loadMongoId, isExpanded, allowResend, onResent }) => {
    const adaptedRow = {
        _id: loadMongoId || emailThreadId,
        emailThreadId,
        emailHistory: { replyPreference: 'MANUAL' },
        posterInfo: {
            companyName: load.brokerCompanyName || '',
            contact: { email: load.brokerContactEmail || load.posterContactEmail || '' },
        },
        origin: { city: load.pickupCity, stateProv: load.pickupStateProv },
        destination: { city: load.deliveryCity, stateProv: load.deliveryStateProv },
    } as unknown as ClientLoadModel

    return <EmailChatCard row={adaptedRow} isExpanded={isExpanded} allowResend={allowResend} onResent={onResent} />
}
